// Single source of truth for the layout breakpoints.
// The numeric constants are exported so JS (see hooks/useIsMobile) can test the
// exact same threshold the CSS below uses - the two must never drift apart.
export const MOBILE_MAX_WIDTH = 1200;
export const SMALL_MOBILE_MAX_WIDTH = 768;

export const breakpoints = {
    mobile: `max-width: ${MOBILE_MAX_WIDTH}px`,
    desktop: `min-width: ${MOBILE_MAX_WIDTH}px`,
    smallMobile: `max-width: ${SMALL_MOBILE_MAX_WIDTH}px`,
};
